import { Parser as HtmlToReactParser } from 'html-to-react';

const htmlToReactParser = new HtmlToReactParser();

export const htmlToReact = htmlInput => {
  const reactElement = htmlToReactParser.parse(htmlInput);
  return reactElement;
};

export const stripTags = html => {
  if (typeof document !== 'undefined') {
    const temporalDivElement = document.createElement('div');
    temporalDivElement.innerHTML = html;
    return temporalDivElement.textContent || temporalDivElement.innerText || '';
  }
};
